import { render, staticRenderFns } from "./UpdateEvaluation.vue?vue&type=template&id=cefb79c6"
import script from "./UpdateEvaluation.vue?vue&type=script&lang=js"
export * from "./UpdateEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports